export default "icons-text-align-left"